import * as React from "react"
import "./style_7.scss"
import {toLower, includes, toUpper} from "lodash";
import { countryCoordinates, countryCoordinates3 } from "../../constants";


export default function ProductContentStyle7({ items, isProductPassportView }) {
    const nonCapitalisedKeys = ['xelakey', 'style number', 'fabric composition', 'size', 'gs1 digital link', 'purchase order number'];
    const hideOnDigitalLink = ['xelakey', 'size'];

    const getValue = (data) => {
        if (['fabric origin', 'main fabric origin', 'country of origin'].includes(toLower(data.label))) {
            const countryData = countryCoordinates[toUpper(data.value)] || countryCoordinates3[toUpper(data.value)];
            return countryData?.name
                || <span className="text-capitalize">{toLower(data.value)}</span>
                || '';
        }
        if (data.value_prepend) {
            return `${data.value_prepend}${data.value}`;
        }
        if (!includes(nonCapitalisedKeys, toLower(data.label))) {
            return toLower(data.value);
        }
        return data.value || '';

    };

    return (items?.map((data, index) => {
        const displayNonDigitals = (!!includes(hideOnDigitalLink, toLower(data.label))) && !!isProductPassportView;

        return (!!Object.keys(data)?.length && !displayNonDigitals && data.value && (
            <div key={index}
                className={`product-content style_7 ${toLower(data.label) === 'brand partner' ? 'custom' : ''} ${!includes(nonCapitalisedKeys, toLower(data.label)) ? 'uk-text-capitalize' : ''}`}
            >
                <div className={`content-block-image`}>
                    <img src={data.image} alt="" />
                </div>
                <div className={`content-block-info`}>
                    <h3>{data.label}</h3>
                    {data.url ? (
                        <a target={`_blank`} href={data.url}>{data?.value || ''}</a>
                    ) : (
                        <div className={`${data?.url_name ? 'description' : ''}`}>
                            <span>{getValue(data)}</span>
                        </div>
                    )}
                </div>
            </div>
        ))
    })
    )
}
